module.exports = __webpack_public_path__ + "static/media/step-forward.0c826593.svg";